import { observer } from 'mobx-react-lite'
import { UnlinkDocumentDialog } from '@/features/documents/UnlinkDocumentDialog'
import { type UnlinkDocumentDialogViewModel } from './UnlinkDocumentDialogViewModel'

export interface UnlinkDocumentDialogContainerProps {
  vm: UnlinkDocumentDialogViewModel
}

export const UnlinkDocumentDialogContainer = observer(
  function UnlinkDocumentDialogContainer({
    vm,
  }: UnlinkDocumentDialogContainerProps) {
    return (
      <UnlinkDocumentDialog
        showing={vm.modal.showing}
        isPending={vm.unlink.pending}
        onConfirm={vm.unlink}
        onDecline={vm.modal.close}
      />
    )
  },
)
